module.exports = __webpack_public_path__ + "static/media/FBET.0ca5abe9.svg";